"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Collapsible, classNames, FlexColumn } from "@opensea/ui-kit";
import { head } from "es-toolkit/array";
import { useSwapContext } from "../../provider/SwapContext";
import { SwapDetailsCollapsedItem } from "./components/SwapDetailsCollapsedItem";
import { SwapDetailsCollapsedItemFragment } from "./components/SwapDetailsCollapsedItem.fragment";
import { SwapDetailsEstimatedDurationItem } from "./components/SwapDetailsEstimatedDurationItem";
import { SwapDetailsEstimatedDurationItemFragment } from "./components/SwapDetailsEstimatedDurationItem.fragment";
import { SwapDetailsGasFeeItem } from "./components/SwapDetailsGasFeeItem";
import { SwapDetailsGasFeeItemFragment } from "./components/SwapDetailsGasFeeItem.fragment";
import { SwapDetailsMarketplaceFeeItem } from "./components/SwapDetailsMarketplaceFeeItem";
import { SwapDetailsMaxSlippageItem } from "./components/SwapDetailsMaxSlippageItem";
import { SwapDetailsMaxSlippageItemFragment } from "./components/SwapDetailsMaxSlippageItem.fragment";
import { SwapDetailsNetworkItem, SwapDetailsNetworkItemFragment } from "./components/SwapDetailsNetworkItem";
import { SwapDetailsProviderFeeItem } from "./components/SwapDetailsProviderFeeItem";
import { SwapDetailsProviderFeeItemFragment } from "./components/SwapDetailsProviderFeeItem.fragment";
import { SwapDetailsProviderItem } from "./components/SwapDetailsProviderItem";
import { SwapDetailsProviderItemFragment } from "./components/SwapDetailsProviderItem.fragment";
import { SwapDetailsSwapImpactItem } from "./components/SwapDetailsSwapImpactItem";
import { SwapDetailsSwapImpactItemFragment } from "./components/SwapDetailsSwapImpactItem.fragment";
export const SwapDetailsFragment = graphql(`
    fragment SwapDetails on SwapQuote {
      swapRoutes {
        ...SwapDetailsCollapsedItem
        ...SwapDetailsProviderItem
        ...SwapDetailsProviderFeeItem
        ...SwapDetailsGasFeeItem
        ...SwapDetailsEstimatedDurationItem
        ...SwapDetailsNetworkItem
        ...SwapDetailsSwapImpactItem
      }
      ...SwapDetailsMaxSlippageItem
    }
  `, [SwapDetailsCollapsedItemFragment, SwapDetailsProviderItemFragment, SwapDetailsProviderFeeItemFragment, SwapDetailsGasFeeItemFragment, SwapDetailsEstimatedDurationItemFragment, SwapDetailsMaxSlippageItemFragment, SwapDetailsNetworkItemFragment, SwapDetailsSwapImpactItemFragment]);
export function SwapDetails(t0) {
  const $ = _c(38);
  const {
    className,
    contentClassName,
    collapsed,
    setCollapsed
  } = t0;
  const {
    quote: quoteKey
  } = useSwapContext();
  let quote;
  let t1;
  if ($[0] !== quoteKey) {
    quote = readFragment(SwapDetailsFragment, quoteKey);
    console.log({
      quoteKey,
      quote
    });
    t1 = quote ? head(quote.swapRoutes) ?? undefined : undefined;
    $[0] = quoteKey;
    $[1] = quote;
    $[2] = t1;
  } else {
    quote = $[1];
    t1 = $[2];
  }
  const swapRoute = t1;
  let t2;
  if ($[3] !== className) {
    t2 = classNames("w-full gap-2 p-4", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== contentClassName) {
    t3 = classNames("gap-4 px-4 pb-4", contentClassName);
    $[5] = contentClassName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[7] !== swapRoute) {
    t4 = <SwapDetailsProviderItem swapRoute={swapRoute} />;
    t5 = <SwapDetailsProviderFeeItem swapRoute={swapRoute} />;
    t6 = <SwapDetailsMarketplaceFeeItem swapRoute={swapRoute} />;
    t7 = <SwapDetailsGasFeeItem swapRoute={swapRoute} />;
    t8 = <SwapDetailsEstimatedDurationItem swapRoute={swapRoute} />;
    t9 = <SwapDetailsSwapImpactItem swapRoute={swapRoute} />;
    $[7] = swapRoute;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  let t10;
  if ($[14] !== quote) {
    t10 = <SwapDetailsMaxSlippageItem quote={quote} />;
    $[14] = quote;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== swapRoute) {
    t11 = <SwapDetailsNetworkItem swapRoute={swapRoute} />;
    $[16] = swapRoute;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t12 = <FlexColumn className={t3}>{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}</FlexColumn>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== setCollapsed) {
    t13 = open => setCollapsed(!open);
    $[28] = setCollapsed;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== collapsed || $[31] !== swapRoute) {
    t14 = <SwapDetailsCollapsedItem collapsed={collapsed} swapRoute={swapRoute} />;
    $[30] = collapsed;
    $[31] = swapRoute;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t12 || $[34] !== t13 || $[35] !== t14 || $[36] !== t2) {
    t15 = <Collapsible className={t2} content={t12} onOpenChange={t13}>{t14}</Collapsible>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t2;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  return t15;
}